import * as types from "../../actions/types/index";
import { setInitialState } from "../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
    promocode: null,
});
export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.CREATE_BROADCASTER_PROFILE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.UPDATE_BROADCASTER_PROFILE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.CREATE_BROADCASTER_PROFILE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload.success
            };
        case types.UPDATE_BROADCASTER_PROFILE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload.success
            };
        case types.CREATE_BROADCASTER_PROFILE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.UPDATE_BROADCASTER_PROFILE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.RESET_CREATE_BROADCASTER_PROFILE:
            return {
                ...state,
                payload: action.payload,
            };
        case types.RESET_UPDATE_BROADCASTER_PROFILE:
            return {
                ...state,
                payload: action.payload,
            };
        case types.UPDATE_PROMOCODE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                promocode: action.payload.response.error,
            };
        case types.UPDATE_PROMOCODE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                promocode: action.payload.success
            };
        case types.UPDATE_PROMOCODE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.RESET_UPDATE_PROMOCODE:
            return {
                ...state,
                promocode: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}